(() => {
  const init=()=>document.querySelectorAll('[data-cantrip-hero]').forEach(el=>{
    if(el.swiper || typeof Swiper==='undefined')return;
    const count=el.querySelectorAll('.swiper-slide').length;
    new Swiper(el,{effect:'coverflow',grabCursor:true,centeredSlides:true,slidesPerView:1.05,spaceBetween:8,loop:count>2,
      autoplay:count>1?{delay:5000,disableOnInteraction:false}:false,
      coverflowEffect:{rotate:0,stretch:0,depth:0,modifier:1,slideShadows:false},
      breakpoints:{750:{slidesPerView:2,spaceBetween:0,coverflowEffect:{rotate:50,stretch:0,depth:100,modifier:1,slideShadows:true}}},
      navigation:{nextEl:el.querySelector('.swiper-button-next'),prevEl:el.querySelector('.swiper-button-prev')}});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
